export class popupLinks {
    constructor(dataAttribute, dataValue) {

        const selectorString = '[' + dataAttribute + '="' + dataValue + '"]';
        this.popupLinks = document.querySelectorAll(selectorString);

        this.events()
    }

    events() {
        const popupLinks = this.popupLinks

        Array.prototype.forEach.call(
            popupLinks,
            (popupLink, index) => {
                popupLink.addEventListener('click', (event) => {
                    event.preventDefault()
                    window.open(popupLink.href, '_blank', 'width=600,height=460')
                })
            }
        )
    }
}